import { cn } from '@/utils/utils_client';
import * as RADIX__context_menu from '@radix-ui/react-context-menu';
import * as React from 'react';

export const UI_PRIMITIVE__context_menu_content = React.forwardRef<
  React.ElementRef<typeof RADIX__context_menu.Content>,
  React.ComponentPropsWithoutRef<typeof RADIX__context_menu.Content>
>(({ className, ...props }, ref) => (
  <RADIX__context_menu.Portal>
    <RADIX__context_menu.Content
      ref={ref}
      className={cn(
        'z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md animate-in fade-in-80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 cursor-default select-none',
        className,
      )}
      {...props}
    />
  </RADIX__context_menu.Portal>
));
UI_PRIMITIVE__context_menu_content.displayName = RADIX__context_menu.Content.displayName;
